import { render, staticRenderFns } from "./newZone.vue?vue&type=template&id=088c68ea&scoped=true&"
import script from "./newZone.vue?vue&type=script&lang=js&"
export * from "./newZone.vue?vue&type=script&lang=js&"
import style0 from "./newZone.vue?vue&type=style&index=0&id=088c68ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088c68ea",
  null
  
)

export default component.exports